module.exports = __webpack_public_path__ + "static/media/1. Speaker Dmitriy Aksakov.238655e3.png";